/**
 * Handle check-out errors
 */
export default {
  methods: {
    /**
     * @vuese
     * Error handling function
     */
    errorHandlingAction(error) {
      this.$logger.debug(error)

      const errorFields = ['CardHolderName', 'CardExpirateDate', 'CardNumber']
      const errors = errorFields
        .filter((field) => error?.[field]?.errorMessages?.length)
        .map((field) => `${error[field].name} ${error[field].errorMessages[0]}`)

      const message = errors.length ? errors.join(', ') : 'Internal Error'

      this.serverErrors.push({
        code: 500,
        message
      })
    }
  }
}
